import { orchestrator, action } from 'satcheljs';
import { initializeFullOptions } from 'owa-options-store';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
import { navigateToOptionLink } from 'owa-options-link';

export interface ShowFullOptionsParameters {
    category?: string;
    subcategory?: string;
    option?: string;
}

const showFullOptions = action(
    'showFullOptions',
    (category?: string, subcategory?: string, option?: string) => ({
        category,
        subcategory,
        option,
    })
);
export default showFullOptions;

export function showFullOptionsOrchestrator({
    category,
    subcategory,
    option,
}: {
    category: string;
    subcategory: string;
    option: string;
}) {
    logUsage(datapoints.ShowFullOptions.datapoint.name);

    initializeFullOptions(category, subcategory, option);
}

orchestrator(showFullOptions, showFullOptionsOrchestrator);
orchestrator(navigateToOptionLink, showFullOptionsOrchestrator);
